/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  GetNameCheckId200,
  PostNameCheck200,
  PostNameCheckBody
} from './schema'



/**
 * @summary Name Check Results
 */
export const getNameCheckId = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetNameCheckId200>> => {
    return axios.get(
      `/name-check/${id}`,options
    );
  }


export const getGetNameCheckIdQueryKey = (id: string,) => [`/name-check/${id}`];

    
export type GetNameCheckIdQueryResult = NonNullable<Awaited<ReturnType<typeof getNameCheckId>>>
export type GetNameCheckIdQueryError = AxiosError<unknown>

export const useGetNameCheckId = <TData = Awaited<ReturnType<typeof getNameCheckId>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNameCheckId>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNameCheckIdQueryKey(id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNameCheckId>>> = ({ signal }) => getNameCheckId(id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getNameCheckId>>, TError, TData>(queryKey, queryFn, {enabled: !!(id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * @summary New Name Check
 */
export const postNameCheck = (
    postNameCheckBody: PostNameCheckBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostNameCheck200>> => {
    return axios.post(
      `/name-check`,
      postNameCheckBody,options
    );
  }



    export type PostNameCheckMutationResult = NonNullable<Awaited<ReturnType<typeof postNameCheck>>>
    export type PostNameCheckMutationBody = PostNameCheckBody
    export type PostNameCheckMutationError = AxiosError<unknown>

    export const usePostNameCheck = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNameCheck>>, TError,{data: PostNameCheckBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNameCheck>>, {data: PostNameCheckBody}> = (props) => {
          const {data} = props ?? {};

          return  postNameCheck(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postNameCheck>>, TError, {data: PostNameCheckBody}, TContext>(mutationFn, mutationOptions)
    }
    